import { HeadTagsConfig } from '@tenants/types/tenant';
import { LOCALE_ZOOCASA_PATHS } from 'types/locales';

export function createHeadTagsConfig(): HeadTagsConfig {
  return {
    defaultTitle: 'Zoocasa Real Estate Listings - Houses, Condos, Property for Sale',
    defaultMetaDescriptionKey: LOCALE_ZOOCASA_PATHS.HEAD_TAGS_DEFAULT_META_DESCRIPTION,
  };
}

